import { render } from "./CoverSearchList.vue?vue&type=template&id=6451ed9a"
import script from "./CoverSearchList.vue?vue&type=script&lang=js"
export * from "./CoverSearchList.vue?vue&type=script&lang=js"

import "./CoverSearchList.vue?vue&type=style&index=0&id=6451ed9a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__